export default __webpack_public_path__ + "static/media/EmptyState.46a5d6ed.svg";